exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  height: 100vh; }\n\n#app,\nwebview {\n  width: 100%;\n  height: 100%; }\n", ""]);

// exports
